import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { useAuth } from "@/context/AuthContext";
import { UserPlus, Music, Users, ArrowRight, Mail } from "lucide-react";

const STEPS = [
  {
    icon: UserPlus,
    title: "Create your account",
    body: "Use the same email you used at checkout — your access unlocks automatically the moment you sign up.",
  },
  {
    icon: Music,
    title: "Build your HausCard",
    body: "Up to 3 songs, your bio, photos, roles and genres. Your calling card goes live instantly.",
  },
  {
    icon: Users,
    title: "Find your people",
    body: "Browse the Haus, hear who's here, and request intros referencing the exact song you loved.",
  },
];

export default function Welcome() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-ink">
      <Header />
      <div className="max-w-[900px] mx-auto px-5 md:px-10 pt-28 pb-24" data-testid="welcome-page">
        <div className="text-center mb-14">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-gold">Membership confirmed</span>
          <h1 className="font-heading text-5xl md:text-7xl font-bold tracking-tighter uppercase text-cream mt-4">
            You're in<span className="text-gold">.</span>
          </h1>
          <p className="text-ash mt-5 max-w-md mx-auto leading-relaxed">
            Welcome to WriterHaus — the room where indie songwriters, artists and producers find each other. The home for indie music makers.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-line border border-line mb-12">
          {STEPS.map((s, i) => (
            <div key={s.title} className="bg-surface p-8 flex flex-col" data-testid={`welcome-step-${i + 1}`}>
              <div className="flex items-center justify-between mb-6">
                <s.icon size={26} className="text-gold" />
                <span className="font-mono text-xs text-ash">0{i + 1}</span>
              </div>
              <h3 className="font-heading text-lg font-bold uppercase tracking-tight text-cream mb-2">{s.title}</h3>
              <p className="text-ash text-sm leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          {user ? (
            <button
              onClick={() => navigate("/directory")}
              data-testid="welcome-directory-btn"
              className="inline-flex items-center justify-center gap-2 bg-gold text-ink font-bold uppercase tracking-widest text-sm px-10 py-4 hover:bg-gold-hi transition-colors"
            >
              Enter the Haus <ArrowRight size={16} />
            </button>
          ) : (
            <button
              onClick={() => navigate("/auth")}
              data-testid="welcome-create-account-btn"
              className="inline-flex items-center justify-center gap-2 bg-gold text-ink font-bold uppercase tracking-widest text-sm px-10 py-4 hover:bg-gold-hi transition-colors"
            >
              Create your account <ArrowRight size={16} />
            </button>
          )}
          <p className="flex items-center justify-center gap-2 font-mono text-[11px] uppercase tracking-wide text-ash/70 mt-6">
            <Mail size={13} className="shrink-0" /> Important: sign up with the same email you used at checkout
          </p>
        </div>
      </div>
    </div>
  );
}
